import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { ShopStore } from "../shop/ShopStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: ShopStore;
}

@inject("externalInterfaceStore")
export class ShopCreditCardBusinessSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                messageComponent={(
                    <i18n.FormattedHTMLMessage
                        id="shop.creditCardBusiness.success"
                        values={{ productName: this.props.store.productName || "-" }}
                    />
                )}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess("creditCardPurchase")}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/shopCreditCardBusiness/ShopCreditCardBusinessSuccess.tsx